enum MaterialTypeEnum {
    NotDefined = "NotDefined",
    ColorMaterial = "ColorMaterial",
    TextureMaterial = "TextureMaterial",
    SvgMaterial = "SvgMaterial",
    SetMaterial = "SetMaterial"
};

export default MaterialTypeEnum;